export default "<h3>November 22, 2018</h3>\r\n<p>Update 0.52 fixes some bugs.</p>";